// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__RSFxD","isSelected":"Chip_isSelected__CxJ5m","base":"Chip_base__YkpNw","sm":"Chip_sm__WjQ52","icon":"Chip_icon__MtqtX","text":"Chip_text__8OlvY"};